import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import TrashIcon from "../../images/icons/TrashIcon.svg";
import { v4 as uuid } from "uuid";
import {
  BtnIconStyle,
  ContentStyle,
  DataGridListStyle,
  SearchBox,
  BtnGroupStyle,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import ConfirmPopup from "../../components/ConfirmPopup";
import { DialogPopup } from "../../components/DialogPopup";
import AddNewFavDrug from "./AddNewFavDrug";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import useFetch from "../../CustomHooks/useFetch";
import {
  MyProfileFavDrugsList,
  RemoveMyProfileFavDrugsById,
} from "../../Apis/AuthApiServices";
import useDebounce from "../../CustomHooks/useDebounce";
import NoRecords from "../../components/NoRecords";
import ErrorOverlay from "../../components/ErrorOverlay";
import YSSnackBar from "../../uikit/YSSnackBar";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

export const rowstData = [
  {
    id: 1,
    drugname: "Cal-Gest Antacid",
    strength: "500",
    strengthunit: "MG",
    doseform: "Tablet Chewable	",
    sig: "1 TABLET 3 TIMES DAILY",
    quantity: "10.0",
    refills: "0",
  },
  {
    id: 2,
    drugname: "Cal-Gest Antacid",
    strength: "500",
    strengthunit: "MG",
    doseform: "Tablet Chewable	",
    sig: "1 TABLET 3 TIMES DAILY",
    quantity: "10.0",
    refills: "0",
  },
  {
    id: 3,
    drugname: "Cal-Gest Antacid",
    strength: "500",
    strengthunit: "MG",
    doseform: "Tablet Chewable	",
    sig: "1 TABLET 3 TIMES DAILY",
    quantity: "10.0",
    refills: "0",
  },
  {
    id: 4,
    drugname: "Cal-Gest Antacid",
    strength: "500",
    strengthunit: "MG",
    doseform: "Tablet Chewable	",
    sig: "1 TABLET 3 TIMES DAILY",
    quantity: "10.0",
    refills: "0",
  },
  {
    id: 5,
    drugname: "Cal-Gest Antacid",
    strength: "500",
    strengthunit: "MG",
    doseform: "Tablet Chewable	",
    sig: "1 TABLET 3 TIMES DAILY",
    quantity: "10.0",
    refills: "0",
  },
];
export default function FavouriteDrugs() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [drugNameInput, setDrugNameInput] = useState("");
  const [selectionData, setSelectionData] = useState("");
  const [deleteFavDrugPopup, setDeleteFavDrugPopup] = useState(false);
  const handleShowDeletePopupClick = () => {
    setDeleteFavDrugPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteFavDrugPopup(false);
  };
  const [addFavDrugPopup, setAddFavDrugPopup] = useState(false);
  const handleShowAddFavDrugPopupClick = () => {
    setAddFavDrugPopup(true);
  };
  const handleHideAddFavDrugPopupClick = () => {
    setAddFavDrugPopup(false);
  };

  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data

  const columnsFavouriteDrugs: GridColDef[] = [
    {
      field: "drugName",
      headerName: "Drug Name",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
    },
    {
      field: "strength",
      headerName: "Dose",
      width: 80,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "strengthunit",
      headerName: "Dose Unit	",
      width: 110,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "doseform",
      headerName: "Dose Form	",
      width: 110,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "sig",
      headerName: "SIG	",
      width: 180,
      cellClassName: "w26",
      headerClassName: "w26",
    },
    {
      field: "quantity",
      headerName: "Quantity	",
      width: 70,
      cellClassName: "w13",
      headerClassName: "w13",
    },
    {
      field: "refills",
      headerName: "Refills	",
      width: 70,
      cellClassName: "w10",
      headerClassName: "w10",
    },
  ];

  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("selectedDrugs", selectionData);
      params.append("doctorId", doctorId);
      const result = await RemoveMyProfileFavDrugsById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        fetchApi();
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const debouncedValue = useDebounce(drugNameInput, 1000);

  const doctorId: any = localStorage.getItem("doctorId");
  const Params = {
    doctorId:
      UserServiceState?.profileGroup > 6
        ? localStorage.getItem("SupervisorDoctorId")
        : localStorage.getItem("doctorId"),
    pageNumber: page,
    drugName: debouncedValue,
  };
  const { data, loading, error, fetchApi }: any = useFetch(
    Params,
    MyProfileFavDrugsList,
    [page, debouncedValue]
  );

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );
  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={0}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12} md={3}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Favorite Drugs{" "}
              <HelpGuideTooltip
                content={
                  <>
                    <Typography component="div" variant="body1">
                      The drugs on the drug list that the doctor has chosen as
                      his or her favorite ones. Instead of repeatedly searching
                      for the same drug, the physician can choose their
                      preferred drug from the list.
                    </Typography>
                  </>
                }
              />
            </Typography>
          </Grid>{" "}
          <Grid item xs={12} md={5} textAlign={"left"}>
            <SearchBox className="searchicon">
              <Typography component="label" color="primary" variant="body2">
                Search by
              </Typography>{" "}
              <TextField
                id="drugname"
                name="DrugName"
                variant="outlined"
                placeholder="Enter Drug name"
                style={{ borderRadius: 100 }}
                onChange={(e) => {
                  setDrugNameInput(e.target.value);
                }}
              />{" "}
            </SearchBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                columnGap: 5,
              }}
            >
              <Typography component="span" variant="body2">
                Selected ({selectionData.length})
              </Typography>
              <BtnIconStyle>
                <Tooltip title="Delete">
                  <IconButton
                    type="button"
                    className="trash"
                    onClick={handleShowDeletePopupClick}
                  >
                    <img src={TrashIcon} alt="Delete" loading="lazy" />
                  </IconButton>
                </Tooltip>
              </BtnIconStyle>
            </Box>
          </Grid>
        </Grid>{" "}
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                columns={columnsFavouriteDrugs}
                rows={data[0]?.items ?? []}
                headerHeight={36}
                paginationMode="server"
                getRowHeight={() => "auto"}
                sortingOrder={["desc", "asc"]}
                autoHeight
                rowHeight={40}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                checkboxSelection
                getRowId={(row) => row.personDrugId ?? uuid()}
                loading={loading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                page={page}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                }}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              {" "}
              <YSButton
                onClick={handleShowAddFavDrugPopupClick}
                className=""
                children={"Add New"}
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
      <DialogPopup
        windowsize={"lg"}
        show={addFavDrugPopup}
        handleShowPopupClick={handleShowAddFavDrugPopupClick}
        handleHidePopupClick={handleHideAddFavDrugPopupClick}
        title="Add New Favorite Drug"
      >
        <AddNewFavDrug
          handleHideAddFavDrugPopupClick={handleHideAddFavDrugPopupClick}
          fetchApi={fetchApi}
        />
      </DialogPopup>
      <DialogPopup
        windowsize={"sm"}
        show={deleteFavDrugPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
